import * as fechador from './fechador'
import { log } from './logger'

export interface StorageKey {
    code: string
    version: number
}

export interface StorageResult {
    version: number
    date: string
    data: object
}

// ************************************************************************
// Local Storage **********************************************************
// ************************************************************************
export const getParsed = (key: StorageKey): StorageResult | null => {
    try {
        const raw = localStorage.getItem(key.code)
        if (!raw) return null

        const parsed = JSON.parse(raw)
        if (!parsed) return null
        if (!('version' in parsed) || parsed.version !== key.version) return null
        if (!('date' in parsed)) return null
        // hydrate Date
        // parsed.date = fechador.fromDateString(parsed.date)
        return parsed
    } catch (err) {
        log.warn('Key:', key.code, ' getParsed fallada:', err)
        return null // storage no disponible
    }
}

export const setJson = (key: StorageKey, json: any): void => {
    try {
        const today = fechador.toYMD(fechador.todayUTC())
        const raw = JSON.stringify({ version: key.version, date: today, data: json })
        localStorage.setItem(key.code, raw)
        // log.debug('safe to localStorage, key:', key.code, ' - date:', today)
        // log.debug('json:', json)
    } catch (err) {
        log.warn('Key:', key.code, 'setJson fallada:', err)
    }
}

export const clearLocalStorage = (key: StorageKey): void => {
    try {
        localStorage.removeItem(key.code)
        log.debug('clear localStorage, key:', key.code)
    } catch {
        // ignorar: storage no disponible
    }
}

// ************************************************************************
// Session ****************************************************************
// ************************************************************************
export const getSession = (key: StorageKey): any => {
    try {
        const raw = sessionStorage.getItem(key.code)
        if (!raw) return null

        const parsed = JSON.parse(raw)
        if (!parsed) return null
        return parsed
    } catch (err) {
        log.warn('Key:', key.code, ' getSession fallada:', err)
        return null // session no disponible
    }
}

export const setSession = (key: StorageKey, json: any): void => {
    try {
        const raw = JSON.stringify(json)
        sessionStorage.setItem(key.code, raw)
        // log.info(`setSession ${key.code}, json:`, json)
    } catch (err) {
        log.warn(`ERROR setSession ${key.code}, json: ${json}`)
    }
}

export const clearSession = (key: StorageKey): void => {
    try {
        sessionStorage.removeItem(key.code)
        log.debug('clear Session, key:', key.code)
    } catch {
        // ignorar: storage no disponible
    }
}
